import React from 'react';
import './Footer.css';

import { Logo, Newsletter } from '../../components'; // Importing the Logo and Newsletter components
import { contactContent, images, services } from '../../constants'; // Importing contact information and services data

// Importing necessary icons from react-icons
import { FaFacebookF, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FaDroplet, FaXTwitter } from "react-icons/fa6";

// Importing Link for navigation
import { Link } from 'react-router-dom';



const Footer = () => {

  return (
    <footer className='footer'>

      <div className='box-container'>

        {/* About Section */}
        <div className='footer-item'>

          <Logo /> {/* Display the Logo component */}
          <p>Your Trusted Partner for Pure, Reliable, and On-Time Water Delivery Solutions.</p> {/* Description for the about section */}

          <div className='info connect'>
            {contactContent
              .filter(contact => contact.id !== 4) // Exclude the contact with id: 4
              .map((contact) => {
                return (
                  <div key={contact.id} className='connect-item'>
                    <div className='icon'>{contact.icon}</div>
                    <span>{contact.content[0]}</span>
                  </div>
                );
              })
            }
          </div>

          {/* Social media icons with links */}
          <div className='social'>
            <a href="/#"><FaFacebookF className='icon' /></a>
            <a href="/#"><FaXTwitter className='icon' /></a>
            <a href="/#"><FaInstagram className='icon' /></a>
            <a href="/#"><FaLinkedin className='icon' /></a>
          </div>

        </div>

        {/* Services Links Section */}
        <div className='footer-item'> 

          <div className='footer-heading'>
            <h2>Our Services</h2>
            <img src={images.heading} alt="Wave-Pic" />
          </div>

          <div className='info links'> 
            {/* Mapping through the services and creating links to each service page */}
            {services.map(service => {
              /* Link to the individual service page */
              return <p key={service.id}><FaDroplet className='icon' /> 
                <Link
                  to={{ 
                    pathname: '/Services/' + service.title, // Dynamically constructing the link path
                  }}
                  location={{service}} // Passing service data to the route
                  state={service} // Passing service data in state
                >
                  {service.title}  {/* Display Service Title */}
                </Link>
              </p>
            })}
          </div>
        </div>

        {/* Useful Links Section */}
        <div className='footer-item'>

          <div className='footer-heading'>
            <h2>Quick Links</h2>
            <img src={images.heading} alt="Wave-Pic" />
          </div>

          {/* Links for easy navigation to various pages */}
          <div className='info links'> 
            <p><FaDroplet className='icon' /><Link to='/About-us'>about Us</Link></p>
            <p><FaDroplet className='icon' /><Link to='/Pricing'>Pricing</Link></p>
            <p><FaDroplet className='icon' /><Link to='/Order-Now'>Order Now</Link></p>
            <p><FaDroplet className='icon' /><Link to='/Projects'>Projects</Link></p>
            <p><FaDroplet className='icon' /><Link to='/Blog-grid'>Blogs</Link></p>
            <p><FaDroplet className='icon' /><Link to='/Contact-us'>contact</Link></p>
          </div>

        </div>

        {/* Newsletter Section */}
        <div className='footer-item'>

          <div className='footer-heading'>
            <h2>Newsletter</h2>
            <img src={images.heading} alt="Wave-Pic" />
          </div>

          <p>Stay updated with the latest news, offers, and tips in water delivery and hydration.</p> {/* Description for the Newsletter section */}

          {/* Newsletter component to subscribe */}
          <Newsletter />

        </div>

      </div>

      <div className='content'>

        {/* Footer content with copyright information */}
        <p>&copy; AquaDrop 2025 All Rights Reserved</p>

      </div>

    </footer>
  )
}

export default Footer;